import React from "react"

import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"

const LogoBigTextBlock = ({ block }) => {
  return (
    <BlockWrapper block={block} blockWidth="content">
      <div className="text-center">
        <Image className="inline-block h-32 mb-8 my-auto" image={block.logo} />
        <div className="text-3xl leading-normal lg:text-4xl lg:leading-normal font-bold">
          {block.text}
        </div>
      </div>
    </BlockWrapper>
  )
}

export default LogoBigTextBlock
